import { render, staticRenderFns } from "./MultiselectAvatar.vue?vue&type=template&id=e6f71b16&scoped=true"
import script from "./MultiselectAvatar.vue?vue&type=script&lang=ts"
export * from "./MultiselectAvatar.vue?vue&type=script&lang=ts"
import style0 from "./MultiselectAvatar.vue?vue&type=style&index=0&id=e6f71b16&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6f71b16",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e6f71b16')) {
      api.createRecord('e6f71b16', component.options)
    } else {
      api.reload('e6f71b16', component.options)
    }
    module.hot.accept("./MultiselectAvatar.vue?vue&type=template&id=e6f71b16&scoped=true", function () {
      api.rerender('e6f71b16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/autocompleteMultiselects/MultiselectAvatar.vue"
export default component.exports